module.exports = __webpack_public_path__ + "maltak0-4.jpg?2ef466fae96acb5a47536d214e9c8be8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/materialy/maltak0-4.jpg
// module id = 71
// module chunks = 0